<template>
  <v-container class="white a4width">
      <v-btn class="pa-2 print-btn d-print-none"
         tile outlined color="success"
         elevation="4"
         @click="printPage()"
         ripple>
         <v-icon left>mdi-printer</v-icon> {{$t('Print')}}
      </v-btn>
    <v-btn class="d-print-none"
        style="float: right;"
        elevation="4" right
        tile outlined color="success"
        @click="$router.go(-1)"
        ripple>
        <v-icon left>mdi-arrow-left</v-icon> {{$t('Back')}}
    </v-btn>
      <div v-for="(wgn, index) in wagons" :key="wgn.Id">
         <p class="page-break d-block" v-if="index > 0"></p>
         <v-layout align-start justify-start wrap >
         <printHeader class="d-print-flex" v-if="index==0"></printHeader>
         <hr align="center" class="mx-6" v-if="index > 0">
         <v-flex xs12>
            <p class="ma-0 pa-1 black--text headline font-weight-bold"
               :class="index==0? '' : 'd-none d-print-block'">
               <u>{{$t('Production Delivery Plan')}}</u>
            </p>
         </v-flex>
         <v-flex xs12>
            <p class="title black--text my-0 mx-2">{{$t('Wagon')}} {{wgn.order}} - {{wgn.name}}</p>
         </v-flex>
         <v-flex xs12 sm6>
            <p class="subtitle-2 black--text my-1 mx-2" >
               {{$t('TMR')}}: {{tmr(wgn.tmr.documentID).code}} - {{tmr(wgn.tmr.documentID).name}}
               <span v-if="tmr(wgn.tmr.documentID).premixkey != ''" class="ms-3">{{$t('Premix')}}</span>
            </p>
         </v-flex>
         <v-flex xs12 sm6>
               <p class="subtitle-2 black--text my-1 mx-0">{{$t('For Days')}}: {{daysToName(wgn.onlyForDays)}}</p>
         </v-flex>

            <PrintWagonSection :wgn="wgn" :tmr="tmr(wgn.tmr.documentID)" :first="index==0">
            </PrintWagonSection>
            <PrintGroupSection :wgn="wgn" :tmr="tmr(wgn.tmr.documentID)">
            </PrintGroupSection>
         <!-- <v-flex xs12>
            <p class="page-break d-block" >&nbsp; </p>
         </v-flex> -->
      </v-layout>
      </div>
  </v-container>
</template>

<script>
import PrintWagonSection from "../components/PrintWagonSection";
import PrintGroupSection from "../components/PrintGroupSection";
import printHeader from "../components/common/PrintHeader";

export default {
   name: "WagonPlanPrint",
   components: {
      PrintWagonSection,
      PrintGroupSection,
      printHeader
   },
   methods: {
      tmr(id) {
         return this.$store.getters.getTMR(id);
      },
      printPage() {
         let saveDrawer = this.$store.getters.getDrawerState;
         this.$store.dispatch("setDrawerState", false);
         this.$nextTick(() => {
            window.print();
            this.$store.dispatch("setDrawerState", saveDrawer);
         });


      },
      daysToName(days) {
      const names =["*", this.$i18n.t('Sun'), this.$i18n.t('Mon'), this.$i18n.t('Tue'), this.$i18n.t('Wed'), this.$i18n.t('Thu'), this.$i18n.t('Fri'), this.$i18n.t('Sat') ];
      let ret=""  ;
      if (days && days.length >0)
        if (days.length == 7)
          return this.$i18n.t('All days of the week')
        else {
          days.forEach(d => ret += names[d] + ", ");
          return ret.substring(0, ret.length - 2);
        }
      else
        return this.$i18n.t('This Wagon is not used in any weekday')
    },
   },
   computed: {
      wagons() {
         return this.$store.getters.getWagons;
      },
      isPremix() {
         //console.log(id, this.tmr(id));
         return  false; //this.tmr(id).premixkey == "" ? "" : "Premix";
      }
  }
};
</script>

<style scoped>
@media print {
   @page {size: A4 landscape;
      orientation: landscape;
   }
   .v-content {
      padding: 16px !important;
   }
   .v-navigation-drawer {
      width: 0;
      transform: translateX(-100%);
   }
	.page-break	{
      display: block;
      box-sizing: content-box !important;
      float: none !important;
      position: static !important;
      page-break-after: always;
   }
   *,
   *:before,
   *:after {
      background: transparent !important;
      color: #000 !important;
   }
}
.a4width {
    /* size: 21cm 29.7cm; */
    padding: 0 !important;
    margin: 0;
}
.print-btn {
    justify-self: right;
    float: right;
}

</style>>
